import { addYears, addDays, startOfHour, startOfMinute } from 'date-fns';
import { useMemo } from 'react';
import type { DateTimeRange } from 'src/apis/transparency-reporting/types';
import { EmptyValue } from 'src/components/data-display/empty-value';
import { FormatDate } from 'src/components/data-display/format-date';
import { useNow } from 'src/hooks/use-now';

export function useDefaultDateRangeBounds(offset = -7) {
  const now = useNow();

  return useMemo(() => {
    const start = addDays(now, offset);

    return {
      start: startOfMinute(start).toISOString(),
      end: startOfMinute(addDays(now, 1)).toISOString(),
      startHour: startOfHour(start).toISOString(),
      endHour: startOfHour(addYears(now, 4)).toISOString(),
    };
  }, [now, offset]);
}

export const FormattedRange = ({ range }: { range?: DateTimeRange }) => {
  return range ? (
    <>
      <FormatDate value={range.from} type="date-time" />
      {' - '}
      <FormatDate value={range.to} type="date-time" />
    </>
  ) : (
    <EmptyValue />
  );
};
